import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import { BASE_URL_SANDBOX, GET_ALL_STORES } from "../../../Constants/Config"
import { createRequestCache } from '../../../utils/requestCache';

const allStoresRequestCache = createRequestCache({
    ttlMs: 2 * 60 * 1000,
    maxEntries: 5,
});

const initialState = {
    loading: false,
    allStoresData: [],
    error: '',
}


// Generate pening , fulfilled and rejected action type
export const fetchAllStoresData = createAsyncThunk('allstores/fetchAllStoresData', async (request = {}, { signal: thunkSignal }) => {
    try {
        const isFormData =
            typeof FormData !== 'undefined' && request instanceof FormData;
        const requestOptions = !isFormData && request ? request : {};
        const forceRefresh = Boolean(
            requestOptions.forceRefresh || requestOptions.payload?.forceRefresh,
        );
        const signal = requestOptions.signal || thunkSignal;
        const requestKey = `${BASE_URL_SANDBOX}${GET_ALL_STORES}`;

        return await allStoresRequestCache.getOrCreate(
            requestKey,
            async () => {
                const response = await axios.post(
                    BASE_URL_SANDBOX + GET_ALL_STORES,
                    { headers: { "Content-Type": "multipart/form-data" } },
                );

                if (response.status !== 200) {
                    throw new Error('Failed to fetch store defaults');
                }

                return response.data;
            },
            { forceRefresh, signal },
        );
    } catch (error) {
        if (error?.name === 'AbortError' || error?.name === 'CanceledError') {
            throw error;
        }
        throw new Error(
            error?.response?.data?.message ||
            error?.message ||
            'Failed to fetch store defaults',
        );
    }
})


const allStoresSlice = createSlice({
    name: 'allstores',
    initialState,
      extraReducers: (builder) => {
        builder.addCase(fetchAllStoresData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(fetchAllStoresData.fulfilled, (state, action) => {
            state.loading = false;
            state.allStoresData = action.payload;
            state.error = '';
        })
        builder.addCase(fetchAllStoresData.rejected, (state, action) => {
            state.loading = false;
            state.allStoresData = {};
            state.error = action.error.message;
        })
               
    }
})


export default allStoresSlice.reducer
